import { get } from 'lodash';

const getZendeskWidgetUrl = (rootState) =>
  get(rootState, 'config.service.common.zendesk.widget_url', '');

export default getZendeskWidgetUrl;
